export default __webpack_public_path__ + "static/media/logo.d66d6d05.png";